import { createBrowserRouter, Navigate } from 'react-router-dom';
import { PublicLayout } from '../layouts/PublicLayout';
import { AuthLayout } from '../layouts/AuthLayout';
import { PortalLayout } from '../layouts/PortalLayout';
import { RequireAuth } from './guards/RequireAuth';
import { RequireRole } from './guards/RequireRole';
import { RedirectIfSignedIn } from './guards/RedirectIfSignedIn';

// Public pages
import { HomePage } from '../pages/public/HomePage';
import { AboutPage } from '../pages/public/AboutPage';
import { PrivacyPage } from '../pages/public/PrivacyPage';
import { TermsPage } from '../pages/public/TermsPage';
import { StaffPortalUnavailablePage } from '../pages/public/StaffPortalUnavailablePage';
import { NotFoundPage } from '../pages/public/NotFoundPage';

// Auth pages
import { LoginPage } from '../pages/auth/LoginPage';
import { SignupPage } from '../pages/auth/SignupPage';
import { SSOCallback } from '../pages/auth/SSOCallback';
import { ForgotPasswordPage } from '../pages/auth/ForgotPasswordPage';

// Customer portal
import { RequestsPage } from '../pages/portal/RequestsPage';
import { NewRequestPage } from '../pages/portal/NewRequestPage';
import { RequestDetailPage } from '../pages/portal/RequestDetailPage';
import { InvoicesPage } from '../pages/portal/InvoicesPage';
import { NotificationsPage } from '../pages/portal/NotificationsPage';
import { ProfilePage } from '../pages/portal/ProfilePage';
import { SavedLocationsPage } from '../pages/portal/SavedLocationsPage';
import { SavedEquipmentPage } from '../pages/portal/SavedEquipmentPage';

export const router = createBrowserRouter([
  // ── PUBLIC ──────────────────────────────────────────────────
  {
    element: <PublicLayout />,
    children: [
      { path: '/', element: <HomePage /> },
      { path: '/about', element: <AboutPage /> },
      { path: '/contact', element: <Navigate to="/#contact" replace /> },
      { path: '/privacy', element: <PrivacyPage /> },
      { path: '/terms', element: <TermsPage /> },
    ],
  },

  // ── AUTH ────────────────────────────────────────────────────
  {
    element: <RedirectIfSignedIn />,
    children: [
      {
        element: <AuthLayout />,
        children: [
          { path: '/login', element: <LoginPage /> },
          { path: '/signup', element: <SignupPage /> },
          { path: '/forgot-password', element: <ForgotPasswordPage /> },
        ],
      },
    ],
  },

  // SSO callback (no layout wrapper needed)
  { path: '/sso-callback', element: <SSOCallback /> },

  // Staff portal unavailable (signed-in non-customer roles land here)
  {
    element: <RequireAuth />,
    children: [{ path: '/staff-portal', element: <StaffPortalUnavailablePage /> }],
  },

  // ── CUSTOMER PORTAL ─────────────────────────────────────────
  {
    element: <RequireAuth />,
    children: [
      {
        element: <RequireRole role="customer" redirectTo="/staff-portal" />,
        children: [
          {
            element: <PortalLayout />,
            children: [
              { path: '/app', element: <Navigate to="/app/requests" replace /> },
              { path: '/app/requests', element: <RequestsPage /> },
              { path: '/app/requests/new', element: <NewRequestPage /> },
              { path: '/app/requests/:id', element: <RequestDetailPage /> },
              { path: '/app/invoices', element: <InvoicesPage /> },
              { path: '/app/notifications', element: <NotificationsPage /> },
              { path: '/app/profile', element: <ProfilePage /> },
              { path: '/app/saved-locations', element: <SavedLocationsPage /> },
              { path: '/app/saved-equipment', element: <SavedEquipmentPage /> },
            ],
          },
        ],
      },
    ],
  },

  // ── CATCH-ALL ───────────────────────────────────────────────
  { path: '*', element: <NotFoundPage /> },
]);
